import React from "react";

export type UseDelay = [boolean, () => void];

export const useDelay = (
  action: () => void,
  delayDuration: number
): UseDelay => {
  const [isDelaying, setIsDelaying] = React.useState(false);

  const onAction = () => {
    setIsDelaying(true);

    const timeout = setTimeout(() => {
      action();
    }, delayDuration);

    return () => clearTimeout(timeout);
  };

  return [isDelaying, onAction];
};
